import { Layout } from '@components/common'
import SearchClient, {
  checkIfSearchTermIsValid,
  getDefaultSearchString,
} from '@lib/algolia'
import getGlobalStaticProps from '@lib/globalStaticProps'
import { getConfigByLocale } from '@lib/locale'
import { createClient } from 'prismicio'
// import HomeAllProductsGrid from '@components/common/HomeAllProductsGrid'
import AlgoliaCollection from '@components/containers/AlgoliaCollection'
import { Locale } from '@lib/types'
import Cookies from 'js-cookie'
import type { GetStaticPropsContext, InferGetStaticPropsType } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

export async function getStaticProps({
  preview,
  locale,
  locales,
  previewData,
}: GetStaticPropsContext) {
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)
  const translations = await serverSideTranslations(locale ?? 'en-au', [
    'common',
  ])
  return {
    props: {
      ...globalProps,
      ...translations,
      categories: [],
      brands: [],
      pages: [],
    },
    //revalidate: 60,
  }
}

export default function Search({}: InferGetStaticPropsType<
  typeof getStaticProps
>) {
  const [showResults, setShowResults] = useState(false)
  const isBot = Cookies.get('IS_BOT')
  const router = useRouter()
  const { t } = useTranslation('common')
  let { query } = useRouter()
  let { q } = query
  if (!q) q = ''
  const algoliaIndex = getConfigByLocale(router.locale, 'algoliaProductIndex')
  const defaultfilterString = getDefaultSearchString()
  const searchTerm = q && Array.isArray(q) ? q[0] : q

  useEffect(() => {
    const isValid =
      searchTerm &&
      searchTerm.length > 0 &&
      router.locale &&
      checkIfSearchTermIsValid(searchTerm, router.locale! as Locale)
    if (isValid) {
      setShowResults(true)
    }
  }, [q, searchTerm, router.locale])
  return (
    <>
      <div className="bg-brand-light-grey">
        <div className="wrapper">
          <h1 className="heading-1 pt-16 pb-6 text-brand-dark-grey lg:pt-30 lg:pb-10">
            <span className="opacity-50">{t('showing-results-for')}</span>
            {` "${q}"`}
          </h1>
        </div>
        {showResults && (
          <AlgoliaCollection
            searchClient={SearchClient}
            indexName={algoliaIndex}
            filterString={defaultfilterString}
            defaultCategory=""
            searchTerm={searchTerm}
            locale={router?.locale}
          />
        )}
      </div>
    </>
  )
}

Search.Layout = Layout
